/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Termination_FirstInputs */

const en_consumer_declaration_termination_first = /** @type {(inputs: Consumer_Declaration_Termination_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel contracts here`)
};

const de_consumer_declaration_termination_first = /** @type {(inputs: Consumer_Declaration_Termination_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verträge hier kündigen`)
};

const fr_consumer_declaration_termination_first = /** @type {(inputs: Consumer_Declaration_Termination_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résilier des contrats ici`)
};

const es_consumer_declaration_termination_first = /** @type {(inputs: Consumer_Declaration_Termination_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar contratos aquí`)
};

const it_consumer_declaration_termination_first = /** @type {(inputs: Consumer_Declaration_Termination_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risolvi i contratti qui`)
};

const nl_consumer_declaration_termination_first = /** @type {(inputs: Consumer_Declaration_Termination_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contracten hier opzeggen`)
};

const pl_consumer_declaration_termination_first = /** @type {(inputs: Consumer_Declaration_Termination_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wypowiedz umowy tutaj`)
};

const fi_consumer_declaration_termination_first = /** @type {(inputs: Consumer_Declaration_Termination_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Irtisano sopimukset tästä`)
};

const da_consumer_declaration_termination_first = /** @type {(inputs: Consumer_Declaration_Termination_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opsig kontrakter her`)
};

const sv_consumer_declaration_termination_first = /** @type {(inputs: Consumer_Declaration_Termination_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säg upp avtal här`)
};

/**
* | output |
* | --- |
* | "Cancel contracts here" |
*
* @param {Consumer_Declaration_Termination_FirstInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_termination_first = /** @type {((inputs?: Consumer_Declaration_Termination_FirstInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Termination_FirstInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_termination_first(inputs)
	if (locale === "fr") return fr_consumer_declaration_termination_first(inputs)
	if (locale === "es") return es_consumer_declaration_termination_first(inputs)
	if (locale === "it") return it_consumer_declaration_termination_first(inputs)
	if (locale === "nl") return nl_consumer_declaration_termination_first(inputs)
	if (locale === "pl") return pl_consumer_declaration_termination_first(inputs)
	if (locale === "fi") return fi_consumer_declaration_termination_first(inputs)
	if (locale === "da") return da_consumer_declaration_termination_first(inputs)
	if (locale === "sv") return sv_consumer_declaration_termination_first(inputs)
	return en_consumer_declaration_termination_first(inputs)
});